var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 275,
    viewBox: "0 0 296 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-48.8516 87.5439L-17.5257 105.63L12.4908 89.8364L-18.835 71.7504L-48.8516 87.5439Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-3.09766 62.5635L28.2282 80.6495L58.2233 64.8436L26.8975 46.7576L-3.09766 62.5635Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6562 37.5869L73.9821 55.6729L103.977 39.867L72.6514 21.781L42.6562 37.5869Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-30.9727 149.263L0.353174 167.349L30.3697 151.555L-0.956095 133.469L-30.9727 149.263Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7812 124.282L46.1071 142.368L76.1237 126.575L44.7978 108.489L14.7812 124.282Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5391 99.3018L91.8649 117.388L121.881 101.594L90.5342 83.4959L60.5391 99.3018Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.289 74.3252L137.615 92.4112L167.61 76.6053L136.284 58.5193L106.289 74.3252Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-13.0938 210.981L18.2321 229.067L48.2374 213.293L16.9115 195.207L-13.0938 210.981Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6641 186.001L63.9899 204.087L94.0065 188.293L62.6806 170.207L32.6641 186.001Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.418 161.021L109.744 179.106L139.76 163.313L108.435 145.227L78.418 161.021Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M124.172 136.044L155.498 154.13L185.514 138.336L154.167 120.238L124.172 136.044Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.926 111.063L201.252 129.149L231.247 113.344L199.921 95.2576L169.926 111.063Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5469 247.72L81.8727 265.806L111.878 250.032L80.5521 231.946L50.5469 247.72Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2969 222.739L127.623 240.825L157.639 225.032L126.313 206.946L96.2969 222.739Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M142.055 197.763L173.381 215.849L203.397 200.055L172.071 181.969L142.055 197.763Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M187.805 172.782L219.131 190.868L249.147 175.075L217.8 156.976L187.805 172.782Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M233.562 147.806L264.888 165.892L294.884 150.086L263.558 132L233.562 147.806Z",
    stroke: "#0000FF",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBg1);
export default __webpack_public_path__ + "static/media/hero_bg1.2b4ebcf65bff13d72b837c683e19f9f5.svg";
export { ForwardRef as ReactComponent };